<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    :value="value"
    :class="[
      mainClass,
      $attrs.class,
    ]"

    :color="defaultColor"
    persistent-placeholder
    :style="[
      $attrs.style,
    ]"
    @input="$emit('input', $event)">
  </v-text-field>
</template>

<script>
export default {
  name: "MajorityTextfield",

  inheritAttrs: false,

  props: {
    value: [String, Number, Boolean, Object, Array],

    regular: {
      type: Boolean,
      default: false,
    },

    outlined: {
      type: Boolean,
      default: false,
    },

    defaultColor: {
      type: String,
      default: 'primary',
    },
  },

  computed: {
    mainClass() {
      return {
        'textfield-default textfield-regular': this.regular,
        'textfield-default textfield-outlined': this.outlined,
        'textfield-disabled': this.isDisabled,
      };
    },

    isDisabled() {
      return this.$attrs.disabled !== undefined && this.$attrs.disabled !== false;
    }
  }

}
</script>

<style lang="scss">
.textfield-default {
  > .v-input__control {
    ::before {
      border-image: none !important;
    }

    > .v-input__slot {
      padding: 0 12px !important;
      min-height: 50px;

      > .v-text-field__slot {
        margin: 0 !important;
        height: 100%;
      }

      &::before,
      &::after,
      :before,
      :after {
        border-color: transparent !important;
        background-color: transparent !important;
      }

      label {
        padding: 0 8px;
        font-size: 16px;
        color: var(--v-foreground-base);
        max-width: 133%;
      }
    }
  }
}

.textfield-regular {
  margin: 0px !important;
  padding: 0px !important;

  > .v-input__control {
    > .v-input__slot {
      border: 2px solid var(--v-border-base) !important;
      border-radius: 8px;

      label {
        background-color: var(--v-muted-base);
        transform: translate(-6px, -26px) scale(0.75);
        pointer-events: auto;
      }
    }
  }
}

.textfield-outlined {
  > .v-input__control {
    > .v-input__slot {
      border: 2px solid var(--v-border-base) !important;
      border-radius: 100px;
    }
  }
}

.textfield-default > .v-input__control > .v-input__slot {
  > .v-text-field__slot > input {
    color: var(--v-foreground-base);
  }
}

.textfield-disabled > .v-input__control > .v-input__slot {
  background: var(--v-muted-base);
}
</style>